import axios from 'axios';
import i18n from '../i18n';

// Longer backend answers are stack traces or HTML pages, not messages for the user
const MAX_BACKEND_MESSAGE_LENGTH = 300;

const getBackendMessage = (data: unknown): string | undefined => {
  if (typeof data !== 'string') return undefined;

  const message = data.trim();
  if (!message || message.length > MAX_BACKEND_MESSAGE_LENGTH) return undefined;

  return message;
};

const getErrorReason = (error: unknown): string | undefined => {
  if (!axios.isAxiosError(error)) return undefined;

  // the request never got an answer: offline, timeout, CORS, server down
  if (!error.response) return i18n.t('apiErrors.network');

  const { status, data } = error.response;
  if (status === 401) return i18n.t('apiErrors.unauthorized');
  if (status === 403) return i18n.t('apiErrors.forbidden');
  // the 500 answer only names the failed function, it doesn't help the user
  if (status >= 500) return i18n.t('apiErrors.server');

  // 400, 404, 409: the backend sends the reason as plain text
  return getBackendMessage(data);
};

/**
 * Builds the message shown to the user when a request fails:
 * the translated text of fallbackKey, followed by the reason of the failure when it is known.
 */
export const getErrorMessage = (
  error: unknown,
  fallbackKey: string
): string => {
  const fallback = i18n.t(fallbackKey);
  const reason = getErrorReason(error);

  if (!reason) return fallback;

  return `${fallback.replace(/[.!]+$/, '')}: ${reason}`;
};
